import { render } from "./integralrule.vue?vue&type=template&id=c6ef69d6&scoped=true&ts=true"
import script from "./integralrule.vue?vue&type=script&setup=true&lang=ts"
export * from "./integralrule.vue?vue&type=script&setup=true&lang=ts"

import "./integralrule.vue?vue&type=style&index=0&id=c6ef69d6&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6ef69d6"],['__file',"src/views/me/integralrule.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6ef69d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6ef69d6', __exports__)) {
    console.log('reload')
    api.reload('c6ef69d6', __exports__)
  }
  
  module.hot.accept("./integralrule.vue?vue&type=template&id=c6ef69d6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('c6ef69d6', render)
  })

}


export default __exports__